import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ResourceComponent } from './resource/resource.component';

const routes: Routes = [
  { path: '', component: ResourceComponent },
  { path: 'what-is-iec-importer-exporter-code', component: ResourceComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VideoResourcesRoutingModule { }
